import {
  isInjectionOnCloseEnabled,
  isInjectionWithoutFormEnabled,
} from './utils';
import { InjectionActionOrigin } from './constants';

export const getSuccessNotificationMessage = (
  actionOrigin: string,
): string | undefined => {
  if (isInjectionOnCloseEnabled()) {
    if (actionOrigin === InjectionActionOrigin.Close) {
      return 'ai_template_injection_legal_skip_notification_text';
    } else if (actionOrigin === InjectionActionOrigin.Submit) {
      return 'ai_template_injection_legal_notification_text';
    }
  } else if (isInjectionWithoutFormEnabled()) {
    return 'ai_template_injection_legal_skip_notification_text';
  }
};
